import { z } from 'zod';

import { FeeId } from '../BrandedIds';
import { Advance } from '../loan/Charges';
import { BaseLoanEvent } from './BaseLoanEvent';

const EditableAdvanceFields = Advance.pick({
  chargeDate: true,
  investorRemittanceSplit: true,
  isDeferred: true,
});

const AdvanceDisbursementUpdate = z.object({
  advanceId: FeeId,
  oldAdvance: EditableAdvanceFields,
  newAdvance: EditableAdvanceFields,
});
export type AdvanceDisbursementUpdate = z.infer<typeof AdvanceDisbursementUpdate>;

export const EditAdvanceDisbursementsEvent = BaseLoanEvent.extend({
  type: z.literal('editAdvanceDisbursements'),
  advanceUpdates: z.array(AdvanceDisbursementUpdate).min(1),
});
export type EditAdvanceDisbursementsEvent = z.infer<typeof EditAdvanceDisbursementsEvent>;
